import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from "@shared/components/platform-tool/platform-link-creator/platform-link-creator.component";

export const PresetCountriesRoutes: Routes = [
  {
    path: 'preset-countries',
    component: PlatformLinkCreatorComponent
  }
];
